__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-27-1777286514-stable-dev/";